export default __webpack_public_path__ + "static/media/steve.695f3792.png";